
import { defineComponent, computed, onMounted, watch, nextTick, provide, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import KTAside from "@/layout/aside/Aside.vue";
import KTHeader from "@/layout/header/Header.vue";
import KTFooter from "@/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/LayoutService";
import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import KTScrollTop from "@/layout/extras/ScrollTop.vue";
import { config } from "@/core/helpers/config";
//import KTUserMenu from "@/layout/header/partials/ActivityDrawer.vue";
import KTLoader from "@/components/Loader.vue";
//import KTCreateApp from "@/components/modals/wizards/CreateAppModal.vue";
import KTDemosDrawer from "@/layout/extras/DemosDrawer.vue";
//import KTHelpDrawer from "@/layout/extras/HelpDrawer.vue";
import KTToolButtons from "@/layout/extras/ToolButtons.vue";
//import KTDrawerMessenger from "@/layout/extras/MessengerDrawer.vue";
import UploadFileModal from "@/components/modals/general/UploadFileModal.vue"
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { MenuComponent } from "@/assets/ts/components";
import { removeModalBackdrop } from "@/core/helpers/dom";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import JwtService from "@/core/services/JwtService";

import {
  toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo,
} from "@/core/helpers/config";

export default defineComponent({
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTFooter,
    KTToolbar,
    KTScrollTop,
    UploadFileModal,
    KTDemosDrawer,
    KTToolButtons,
    KTLoader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    
    //provide sharind data
    //const periodo = ref("")
    const listEvents = ref([])
    const filter = ref({})
    const gblRowAcrd = ref({})
    const dialogPhoto = ref(false)
    const gblPhoto = ref({})
    
    const gblDataPhoto = ref({})

    //variables globales generales
    const gblAction = ref('') //variable global de accion : new, edit
    const gblDialog = ref(false) //variable global de modal: open, close
    const gblDrawer1 = ref(false)
    const gblPeriodo = ref('')
    //variables globales especificas
    const gblPersona = ref({})
    const gblAccount = ref<any>({})
    const gblCompany = ref<any>({});

    //Variables globales
    provide ('gblAction', gblAction)
    provide ('gblDialog', gblDialog)
    provide ('gblDrawer1', gblDrawer1)
    provide ('gblPeriodo', gblPeriodo)
    provide ('gblCompany', gblCompany);

    //provide ('listEvents', listEvents)
    //provide ('filter', filter)
    provide ('gblRowAcrd', gblRowAcrd)
    provide ('gblPersona', gblPersona)
    

    //modalphoto
    provide ('dialogPhoto', dialogPhoto)
    provide ('gblPhoto', gblPhoto)
    provide ('gblDataPhoto', gblDataPhoto)

    provide('gblAccount', gblAccount)

    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });

    const getCompany = computed(() => {
      gblCompany.value = store.getters.currentUser?.company;
      return store.getters.currentUser?.company
    })

    const processResponse = (data) => {
      gblPhoto.value = data
      if(data.status == 'success'){
        dialogPhoto.value = false
      }
    }

    onMounted(() => {
      //check if current user is authenticated
      if (!store.getters.isUserAuthenticated) {
        router.push({ name: "sign-in" });
      }

      //config.value.aside.display = true
      //config.value.header.width = 'fluid'
      //localStorage.setItem("config", JSON.stringify(config.value));

      store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() })

      nextTick(() => {
        reinitializeComponents();
      });

      // Simulate the delay page loading
      setTimeout(() => {
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }, 500);
    });

    watch(
      () => route.path,
      () => {
        MenuComponent.hideDropdowns(undefined);

        // check if current user is authenticated
        if (!store.getters.isUserAuthenticated) {
          router.push({ name: "sign-in" });
        }

        gblAccount.value = store.getters.currentUser.account;
        //por revisar este tema
        localStorage.setItem("account", JSON.stringify(gblAccount.value));

        nextTick(() => {
          reinitializeComponents();
        });

        removeModalBackdrop();
      }
    );

    return {
      config,
      filter,
      listEvents,
      toolbarDisplay,
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      pageTitle,
      breadcrumbs,
      getCompany,
      themeLightLogo,
      themeDarkLogo,
      processResponse
    };
  },
});
